import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import QueryManagementTeams from 'graphql/queries/management/QueryManagementTeams'
import QueryManagementTeamsNoCount from "graphql/queries/management/QueryManagementTeamsNoCount";
import store from 'services/redux/store'
import { setManagementByGuid } from 'services/redux/management/actions'
import { managementConstants } from 'services/redux/management/constants'

export default class FetchManagementTeam {
	
	static fetchAll( { callbackSuccess = null, callbackError = null, callbackStart = null, employeeCount = true, variables = {}, dispatchDataToStore = true } = {} ) {
		const query = employeeCount ? QueryManagementTeams : QueryManagementTeamsNoCount;

		new GraphqlBuilder()
			.addQuery( 'teams', query, variables )
			.setResultPath( ['teams', 'teams'], [] )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				
				if( dispatchDataToStore ) {
					store.dispatch( setManagementByGuid( managementConstants.TEAMS, result ) )
				}
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						teams: result
					});
				}
			})
			.execute()
	}
}
